/**
 * Shared client-record status vocabulary (TASK-654).
 *
 * The audit found the SAME record rendered with different literals on the same
 * page ("In progress"/"Not on file yet" vs "In Progress"/"Not started"). Every
 * surface must derive its label from the backend status through ONE function.
 * Backend risk-profile statuses: not_started | draft/in_progress | completed
 * (see risk_profile_routes.get_risk_profile).
 */

export type RiskProfileDisplayStatus = 'Completed' | 'In progress' | 'Not started';

export function riskProfileStatusLabel(
  riskProfile: Record<string, unknown> | null | undefined,
): RiskProfileDisplayStatus {
  if (!riskProfile || Object.keys(riskProfile).length === 0) return 'Not started';
  if (riskProfile.status === 'completed') return 'Completed';
  return 'In progress';
}
